import React, { useState } from 'react';

const AOSPOperations = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const operations = [
        { title: 'Federated e-infrastructure', description: 'A scalable and integrated e-infrastructure supporting data-driven research and collaboration such as <a class="text-blue-600 cursor-pointer" href="/initiatives">CST Cloud - AOSP EA</a>' },
        { title: 'Policies, practices, tools of research data management', description: 'Developing and promoting best practices, policies, and tools for efficient and effective data management.' },
        { title: 'Data Science and AI Institute', description: 'An institute dedicated to advancing data science, AI, and their applications in science and innovation.' },
        { title: 'Programme delivery', description: 'Ensuring the successful delivery of various science, education, and societal engagement programmes.' },
        { title: 'Science programmes', description: 'Driving cutting-edge scientific research and innovations through collaborative programmes.' },
        { title: 'Education and skills programmes', description: 'Providing capacity-building, training, and education in science and technology.' },
        { title: 'Societal engagement, dialogue, and policy', description: 'Facilitating societal dialogue and policy engagement to bridge the gap between science and society.' }
    ];

    return (
        <section className="bg-gray-50 py-16 px-6 lg:px-24">
            <div className="max-w-6xl mx-auto text-center">
                <h2 className="text-4xl font-semibold text-gray-800 mb-8">
                    AOSP Operations
                </h2>
                <p className="text-lg text-gray-700 mb-12">
                    The operations of the AOSP span several key areas that enable the development, implementation,
                    and delivery of innovative science and technology programmes across the continent and globally.
                </p>

                <div className="space-y-4">
                    {operations.map((operation, index) => (
                        <div key={index} className="bg-white rounded-lg shadow-md">
                            <button
                                onClick={() => handleToggle(index)}
                                className="w-full p-4 text-left flex justify-between items-center bg-gray-200 hover:bg-gray-300 rounded-t-lg transition-colors"
                            >
                                <span className="text-sm font-semibold text-gray-800">{operation.title}</span>
                                <svg
                                    className={`w-6 h-6 text-gray-600 transition-transform duration-300 ${activeIndex === index ? 'rotate-180' : ''}`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-50 text-gray-700 rounded-b-lg">>
                                    <p dangerouslySetInnerHTML={{__html: operation.description}}/>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default AOSPOperations;
